export default __webpack_public_path__ + "static/web-nav-6aeec9a3a3baf2b5d735f4f15b41c5ca.svg";